import React from "react";
import {
  FormControl,
  Checkbox,
  Switch,
  Box,
  FormLabel,
  Input,
} from "@chakra-ui/react";
const InputField = ({ field, parentKey, handleOnChange }) => {
  return (
    <Box>
      <FormControl mb="12px">
        <Checkbox
          fontSize="16px"
          fontWeight="600"
          color="#12344D"
          // mt="3"
          isChecked={field.showField}
          onChange={(e) =>
            handleOnChange({
              value: e.target.checked,
              type: "child",
              parentPropKey: parentKey,
              childPropKey: "showField",
            })
          }
        >
          {field.label}
        </Checkbox>
      </FormControl>
      <FormControl mb="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Label
        </FormLabel>
        <Input
          mt="4px"
          w="378px"
          h="32px"
          borderRadius="4px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          type="text"
          value={field.label}
          placeholder="Enter Label"
          color="#12344D"
          onChange={(e) =>
            handleOnChange({
              value: e.target.value,
              type: "child",
              parentPropKey: parentKey,
              childPropKey: "label",
            })
          }
        />
      </FormControl>
      <FormControl mb="12px">
        <FormLabel fontSize="12px" fontWeight="600" mb="4px" color="#475867">
          Add a new placeholder
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          fontSize="14px"
          placeholderTextColor="red"
          fontWeight="600"
          borderRadius="4px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          type="text"
          value={field.placeholder}
          placeholder="Enter placeholder"
          color="#12344D"
          onChange={(e) =>
            handleOnChange({
              value: e.target.value,
              type: "child",
              parentPropKey: parentKey,
              childPropKey: "placeholder",
            })
          }
        />
      </FormControl>
      <FormControl display="flex" alignItems="center">
        <Switch
          isChecked={field.isRequired}
          onChange={(e) =>
            handleOnChange({
              value: e.target.checked,
              type: "child",
              parentPropKey: parentKey,
              childPropKey: "isRequired",
            })
          }
        />
        <FormLabel htmlFor="required" ml="8px" fontSize="14px" color="#12344D">
          Required
        </FormLabel>
      </FormControl>
    </Box>
  );
};

export default InputField;
